import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';
import pluralize from 'rebook/apps/utils/text/pluralize';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import { URLS } from 'rebook/apps/base/constants';

import styles from './style.scss';


const NicheCatalogBestsellers = ({ bestsellersBookset, booksTotalCounter, title }) => (
  <div className="billetContainerNoOverflow">
    {bestsellersBookset
      ? (
        <React.Fragment>
          <div className="billetContainerWrapper">
            <div className={styles.name}>
              <div>
                <div className="title-2">{title || 'Все книги'}</div>
                <span className={styles.subtitle}>
                  {numberWithSpace(booksTotalCounter)}&nbsp;
                  {pluralize(booksTotalCounter, 'книга', 'книги', 'книг')}
                </span>
              </div>
              <div>
                <Link to={URLS.catalogBookList}>
                  <span className={classNames('link', styles.linkName)}>Все книги</span>
                  <span className="shortArrow" />
                </Link>
              </div>
            </div>
          </div>
          <VerticalBookCardList bookList={bestsellersBookset.books} />
        </React.Fragment>
      )
      : (
        <React.Fragment>
          <div className="billetContainerWrapper">
            <div className={styles.titleEmpty} />
            <div className={styles.subTitleEmpty} />
          </div>
          <VerticalBookCardList />
        </React.Fragment>
      )
    }
  </div>
);

export default NicheCatalogBestsellers;
